import React from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import {
  updateCandidateResume,
  updatePersonalDetails,
  updateSkills,
  updateWorkingStatus,
  uploadResume,
} from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import AddEmployement from "../../../Common/AddEmployement/AddEmployement";
import AddQualification from "../../../Common/AddQualification/AddQualification";
import DeactivateModal from "../../../Common/DeactivateModal/DeactivateModal";
import EditPersonalDetails from "../../../Common/EdiPersonalDetails/EditPersonalDetails";
import EditPreference from "../../../Common/EditPreference/EditPreference";
import FileViewer from "../../../Common/FileViewer/FileViewer";
import SwitchComponent from "../../../Common/SwitchComponent/SwitchComponent";
import Notification from "../../../Portals/Notification/Notification";
import ResetPasswordModal from "../../../Portals/ResetPasswordModal/ResetPasswordModal";
import { MainContext } from "../../DashboardContext/Context";
import "./user-profile.style.scss";
export default function UserProfile() {
  const history = useHistory();
  const context = React.useContext(MainContext);
  const [deactivateModal, setDeactivateModal] = React.useState(false);
  const [openReset, setOpenReset] = React.useState(false);
  const {
    userDetails,
    initialChecking,
    updateState,
    collegeData,
    qualificationData,
    specializationData,
  } = context;
  const [available, setAvailable] = React.useState(true);
  const [changing, setChanging] = React.useState(false);
  const [resumeLink, setResumeLink] = React.useState("");
  const [editEmployment, setEditEmployment] = React.useState({
    id: "",
    data: null,
  });
  const [editEducation, setEditEducation] = React.useState({
    id: "",
    data: null,
  });
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openPreference, setOpenPreference] = React.useState(false);
  const [openEditSkills, setOpenEditSkills] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [vieFile, setViewFile] = React.useState(false);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [addNew, setAddNew] = React.useState({
    employment: false,
    qualification: false,
  });
  const handleChange = async (event) => {
    setLoading(true);
    let doc = event.target.files[0];
    let ext = doc?.name?.toString()?.split(".");
    if (ext?.length > 1) {
      let extension = ext[ext?.length - 1];
      if (extension === "docx" || extension === "pdf") {
      } else {
        setLoading(false);
        setNotification({
          status: true,
          title: "Please Select only PDF or DOC file",
        });
        return;
      }
    } else {
      setLoading(false);
      setNotification({
        status: true,
        title: "Please Select only PDF or DOC file",
      });
      return;
    }
    if (doc.size > 10000000) {
      setNotification({
        status: true,
        title: "File must be less than 10MB",
      });
      return;
    }
    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      if (res.data.data) {
        setResumeLink(res.data.data.file_link);
        handleUpdate(res.data.data.file_link);
        setNotification({
          status: true,
          title: "Resume Updated",
        });
      } else {
        setNotification({
          status: true,
          title: res.data.message,
        });
      }
    } catch (error) {
      setNotification({
        status: true,
        title: "Something Went Wrong",
      });
    }

    setLoading(false);
  };
  const handleUpdate = async (link) => {
    try {
      let res = await updateCandidateResume({ candidate_resume: link });
      if (!res.data.error) {
        initialChecking();
      } else {
        setNotification({
          status: true,
          title: res.data.message,
        });
      }
    } catch (error) {
      setNotification({
        status: true,
        title: "Something Went Wrong",
      });
    }
  };
  const updateBasicDetails = async (data) => {
    setLoading(true);
    try {
      let res = await updatePersonalDetails({ ...data });
      if (!res.data.error) {
        initialChecking();
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: "",
        });
        setOpenEdit(false);
        setOpenEditSkills(false);
        setUploading(false);
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  };

  const handleImage = async (event) => {
    setUploading(true);
    let link;
    let doc = event.target.files[0];

    let ext = doc?.name?.toString()?.split(".");
    if (ext?.length > 1) {
      let extension = ext[ext?.length - 1];
      if (extension === "jpeg" || extension === "jpg" || extension === "png") {
      } else {
        setUploading(false);
        setNotification({
          status: true,
          title: "Please Select only JPEG or PNG file",
        });
        return;
      }
    } else {
      setUploading(false);
      setNotification({
        status: true,
        title: "Please Select only JPEG or PNG file",
      });
      return;
    }

    if (doc.size > 10000000) {
      setUploading(false);
      setNotification({
        status: true,
        title: "File must be less than 10MB",
      });
      return;
    }

    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      if (res.data.data) {
        link = res.data.data.file_link;

        let temp = {
          candidate_full_name: userDetails.candidate_full_name,
          candidate_primary_contact_no:
            userDetails.candidate_primary_contact_no,
          candidate_gender: userDetails.candidate_gender,
          candidate_current_location: userDetails.candidate_current_location,
          candidate_img: link,
          candidate_email: userDetails.candidate_email,
          candidate_id: userDetails.candidate_id,
          user_id: userDetails.user_id,
        };
        updateBasicDetails(temp);
      } else {
        setUploading(false);
      }
    } catch (error) {
      setUploading(false);
    }
  };

  const changeWorkingStatus = async (val) => {
    setChanging(true);
    setAvailable(val);
    try {
      let res = await updateWorkingStatus({ work_status: val });
      if (res.data.data) {
        initialChecking();
      } else {
      }
    } catch (error) {
      setChanging(false);
    }
  };

  const changeSkills = async (data) => {
    setOpenEditSkills(false);
    try {
      let res = await updateSkills(data);
      if (res.data.data) {
        initialChecking();
      } else {
        setNotification({
          status: true,
          title: res.data.message,
        });
      }
    } catch (error) {
      setNotification({
        status: true,
        title: "Something went wrong.",
      });
    }
  };
  React.useEffect(() => {
    updateState("jobListPage", "profile");
  }, []);
  React.useEffect(() => {
    let token = localStorage.getItem("userToken");

    if ((userDetails !== null && !userDetails) || !token) {
      history.push("/login");
    }
  }, [userDetails]);
  React.useEffect(() => {
    if (!userDetails) return;
    setAvailable(userDetails.work_status);

    setResumeLink(userDetails.candidate_resume);
  }, [userDetails]);
  return !userDetails ? (
    "Loading...."
  ) : (
    <div className="user-profile-main">
      {deactivateModal ? (
        <DeactivateModal closeIt={() => setDeactivateModal(false)} />
      ) : (
        ""
      )}
      {openReset ? (
        <ResetPasswordModal closeIt={() => setOpenReset(false)} />
      ) : (
        ""
      )}
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      {openPreference ? (
        <EditPreference
          setNotification={setNotification}
          notification={notification}
          closeIt={() => setOpenPreference(false)}
        />
      ) : (
        ""
      )}
      {editEmployment.id && (
        <AddEmployement
          edit={true}
          initialChecking={initialChecking}
          userDetails={userDetails}
          setNotification={setNotification}
          notification={notification}
          editData={editEmployment.data}
          closeIt={() => setEditEmployment({ id: "", data: null })}
        />
      )}
      {editEducation.id && (
        <AddQualification
          editData={{ ...schema, ...editEducation.data }}
          edit={true}
          userDetails={userDetails}
          setNotification={setNotification}
          closeIt={() => setEditEducation({ id: "", data: null })}
        />
      )}
      {addNew.qualification && (
        <AddQualification
          setNotification={setNotification}
          closeIt={() => setAddNew({ ...addNew, qualification: false })}
        />
      )}
      {addNew.employment && (
        <AddEmployement
          initialChecking={initialChecking}
          notification={notification}
          setNotification={setNotification}
          userDetails={userDetails}
          closeIt={() => setAddNew({ ...addNew, employment: false })}
        />
      )}
      {openEdit && (
        <EditPersonalDetails
          message="Edit Personal Details"
          data={userDetails}
          closeIt={() => setOpenEdit(false)}
          onSubmit={(data) => {
            updateBasicDetails(data);
          }}
          loading={loading}
        />
      )}
      {openEditSkills ? (
        <EditPersonalDetails
          onlySKills={true}
          changeSkills={changeSkills}
          message="Edit Skills"
          data={userDetails}
          closeIt={() => setOpenEditSkills(false)}
          onSubmit={(data) => {
            updateBasicDetails(data);
          }}
          loading={loading}
        />
      ) : (
        ""
      )}
      {vieFile ? (
        <FileViewer
          file={userDetails.candidate_resume}
          closeIt={() => setViewFile(false)}
        />
      ) : (
        ""
      )}
      <header className="upm-header">
        <h5>Personal details</h5>
      </header>
      <div className="upm-basic-info-row">
        <button
          disabled={loading}
          onClick={() => setOpenEdit(true)}
          className="edit-details-button"
        >
          <img src={Images.pencilIcon} alt="edit" />
        </button>
        <div className="ubir-first">
          <div className="ubirf-profile">
            <label htmlFor="new-dp">
              {uploading ? (
                <img
                  height="25px"
                  src="https://img.icons8.com/ios-glyphs/90/000000/refresh--v1.png"
                />
              ) : (
                <img
                  className="main-image"
                  src={
                    (userDetails && userDetails.candidate_img) ||
                    "https://img.icons8.com/office/48/000000/user-male-skin-type-5.png"
                  }
                />
              )}
              <input
                onChange={(e) => {
                  handleImage(e);
                  e.target.value = "";
                }}
                accept="image/*"
                className="d-none"
                id="new-dp"
                type="file"
              />
              <span>
                <img src={Images.blueCamera} />
              </span>
            </label>
            <div>
              <h6>{userDetails?.candidate_full_name}</h6>
              <span>ID {localStorage.getItem("iSmartID") || ""}</span>
            </div>
          </div>
          <div className="ubir-working-status">
            <p>Working Status</p>
            <div>
              <h6>Not Available</h6>
              <SwitchComponent
                style={{ margin: "0 8px" }}
                state={available}
                changeState={() => changeWorkingStatus(!available)}
              />
              <h6>Available to work</h6>
            </div>
          </div>
        </div>
        <div className="ubir-second">
          <div className="ubirs-row">
            <p>
              <img src={Images.email} />
              <span>{userDetails && userDetails?.candidate_email}</span>
            </p>
          </div>
          <div className="ubirs-row">
            <p>
              <img src={Images.userLogo} />
              <span>{userDetails && userDetails.candidate_gender}</span>
            </p>
          </div>
          <div className="ubirs-row">
            <p>
              <img src={Images.callLogo} />
              <span>
                {userDetails && userDetails.candidate_primary_contact_no}
              </span>
              {/* <button>Verify</button> */}
            </p>
          </div>
          <div className="ubirs-row">
            <p>
              <img src={Images.manWIthStars} />
              <span>
                {!userDetails?.candidate_total_experience
                  ? "Fresher"
                  : `${userDetails.candidate_total_experience} Years`}
              </span>
            </p>
          </div>
          <div className="ubirs-row">
            <p>
              <img src={Images.locationLogo} />
              <span>
                {userDetails && userDetails.candidate_current_location}
              </span>
            </p>
          </div>
        </div>
        <div className="ubir-third">
          <div className="ubirt-cp">
            <p onClick={() => setOpenReset(!openReset)}>Change Password</p>
          </div>
          <div className="resume-upload-area">
            <h6 className="rua-title">
              Your Resume{" "}
              <a href={userDetails?.candidate_resume} download>
                Download
              </a>
            </h6>
            <label htmlFor="resume" className="upload-area">
              <input
                onChange={(e) => {
                  handleChange(e);
                  e.target.value = "";
                }}
                id="resume"
                className="d-none"
                type="file"
                accept=".pdf, .docx, .doc"
              />
              <img src={Images.uploadLogo} />
              <div>
                <h6>
                  Drag & drop here or{" "}
                  <span style={{ marginLeft: "5px" }}> Browse files</span>
                </h6>
                <p>Resume (Only docs & pdf max upto 5 MB)</p>
              </div>
            </label>
          </div>
        </div>
      </div>

      <div className="ubir-middle-section">
        <section className="ubir-middle-section-left">
          <div className="ubi-cards-wrapper">
            <heder className="ubicw-header">
              <h5>Employment History</h5>
              <button
                onClick={() => setAddNew({ ...addNew, employment: true })}
              >
                <img src={Images.addIcon} />
                Add New
              </button>
            </heder>
            <div className="ubicw-body">
              {userDetails && !userDetails?.candidate_employment?.length ? (
                <div className="empty-data">
                  <button>
                    <img src={Images.noSuitCase} />
                  </button>
                  <div>
                    <p>No Details Found</p>
                    <button
                      onClick={() => setAddNew({ ...addNew, employment: true })}
                    >
                      Add Details
                    </button>
                  </div>
                </div>
              ) : (
                userDetails.candidate_employment.map((obj) => (
                  <div className="ubicw-card">
                    <button
                      disabled={loading}
                      onClick={() =>
                        setEditEmployment({ id: obj._id, data: obj })
                      }
                      className="edit-details-button"
                    >
                      <img src={Images.pencilIcon} alt="edit" />
                    </button>
                    <figure>
                      <img src={Images.menTree} />
                    </figure>
                    <figcaption>
                      <h5>{obj.designation.toUpperCase()}</h5>
                      <h6>{obj.institute_name}</h6>
                      <p>
                        {obj.worked_from.month.toUpperCase() +
                          " " +
                          obj.worked_from.year}{" "}
                        - {obj.currently_working ? "Present" : ""}{" "}
                      </p>
                      <p>Bangalore India</p>
                    </figcaption>
                  </div>
                ))
              )}
            </div>
          </div>
        </section>
        <section className="ubir-middle-section-right">
          <div className="ubir-sc-section">
            <header className="ubir-scs-header">
              <h5>Certification & Skills</h5>
            </header>
            <div className="ubir-scs-body">
              {!userDetails || !userDetails?.candidate_skill?.length ? (
                <div className="empty-data">
                  <button>
                    <img src={Images.noSuitCase} />
                  </button>
                  <div>
                    <p>No Details Found</p>
                    <button onClick={() => setOpenEditSkills(true)}>
                      Add Details
                    </button>
                  </div>
                </div>
              ) : (
                <div className="skills-section">
                  <div className="skills-section-header">
                    <h5>SKills</h5>
                    <button onClick={() => setOpenEditSkills(true)}>
                      <img src={Images.pencilIcon} alt="edit" />
                    </button>
                  </div>
                  <div className="skills-wrapper">
                    {!userDetails || !userDetails?.candidate_skill?.length ? (
                      <button>No skills found</button>
                    ) : (
                      userDetails?.candidate_skill.map((x) => (
                        <button>{x}</button>
                      ))
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>

      <div style={{ marginTop: "20px" }} className="ubi-cards-wrapper">
        <heder className="ubicw-header">
          <h5>Qualification</h5>
          <button onClick={() => setAddNew({ ...addNew, qualification: true })}>
            <img src={Images.addIcon} />
            Add New
          </button>
        </heder>
        <div className="ubicw-body">
          {userDetails && !userDetails?.candidate_qualification?.length ? (
            <div className="empty-data">
              <button>
                <img src={Images.noSuitCase} />
              </button>
              <div>
                <p>No Details Found</p>
                <button
                  onClick={() => setAddNew({ ...addNew, qualification: true })}
                >
                  Add Details
                </button>
              </div>
            </div>
          ) : (
            userDetails.candidate_qualification.map((obj) => (
              <div className="ubicw-card">
                <button
                  disabled={loading}
                  onClick={() => setEditEducation({ id: obj._id, data: obj })}
                  className="edit-details-button"
                >
                  <img src={Images.pencilIcon} alt="edit" />
                </button>
                <figure>
                  <img src={Images.menTree} />
                </figure>

                <figcaption>
                  <h5>{collegeData?.[obj.college]?.college_name}</h5>
                  <p>
                    {
                      specializationData?.[obj.specialization]
                        ?.specialization_name
                    }
                  </p>
                  <p>{obj.passing_year}</p>
                </figcaption>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="ubi-preference">
        <header className="ubip-header">
          <h5>Preference</h5>
        </header>
        <div className="ubip-body">
          <button
            disabled={loading}
            onClick={() => setOpenPreference(true)}
            className="edit-details-button"
          >
            <img src={Images.pencilIcon} alt="edit" />
          </button>
          <p>
            <span>Expected Salary</span> :{" "}
            <span>{userDetails && userDetails.candidate_expected_salary}</span>
          </p>

          <p>
            <span>Preferred Location</span> :{" "}
            <span>
              {!userDetails?.candidate_location?.[0]
                ? "None"
                : `${userDetails?.candidate_location?.[0]?.location_name} & 50 km from distance`}
            </span>
          </p>
          <p>
            <span>Ready To Relocate</span> :{" "}
            <span>
              {userDetails && userDetails?.candidate_relocate ? "Yes" : "No"}
            </span>
          </p>
          <p>
            <span>Online Coaching</span> :{" "}
            <span>
              {userDetails && userDetails?.candidate_coaching ? "Yes" : "No"}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

const schema = {
  qualification: "",
  others: [],
  other_qualification: {
    _id: "",
    name: "",
  },
  specialization: "",
  other_specialization: {
    _id: "",
    name: "",
  },
  university: "",
  other_university: {
    _id: "",
    name: "",
  },
  college: "",
  other_college: {
    _id: "",
    name: "",
  },
  passing_year: "",
  course_type: "",
};
